<template>
  <drop-down class="md-layout-item" direction="down">
    <div class="dropdown-toggle" slot="title" data-toggle="dropdown">
      <label>
        {{ title }}
      </label>
      <div>
        <md-input
          v-model="inputString"
          type="text"
          @focus="updateInput"
        ></md-input>
      </div>
    </div>
    <ul class="dropdown-menu">
      <li v-for="(item, index) in items" :key="index" @click="select(index)">
        <a>{{ item.label }}</a>
      </li>
    </ul>
  </drop-down>
</template>

<script>
export default {
  props: {
    title: String,
    items: Array,
    defaultValue: String,
    onSelect: Function,
  },
  data() {
    return {
      inputString: '',
      selectedItem: null,
    };
  },
  methods: {
    select(index) {
      if (this.items[index] !== undefined) {
        this.selectedItem = this.items[index];
        this.inputString = this.selectedItem.label;
        this.$emit('selected', this.selectedItem);
        if (this.onSelect) this.onSelect();
      }
    },
    updateInput() {
      this.$emit('updatedInput', this.inputString);
    },
  },
  watch: {
    inputString() {
      this.$emit('updatedInput', this.inputString);
    },
    defaultValue: {
      handler (to, from) {
        if (!from) this.inputString = to;
      },
    },
    // ,
    // selectedItem: {
    //     handler: function(value) {
    //         this.inputString = value.label
    //     },
    //     deep: true
    // }
  },
  mounted() {
    if (this.defaultValue) this.inputString = this.defaultValue;
  },
};
</script>

<style scoped>
.md-input {
  width: 100%;
}
</style>
